import { render } from "./PdpNoProductData.vue?vue&type=template&id=61ea0b9f"
import script from "./PdpNoProductData.vue?vue&type=script&lang=js"
export * from "./PdpNoProductData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__